import context from '../context'
// import getComponentKey from '@/utils/getComponentKey'

export const initialState = {
  fetching: false,
  updating: false,
  phone: null
}

export const actionTypes = {
  Fetching: 'phoneNumber/fetching',
  Fetched: 'phoneNumber/fetched',
  Updating: 'phoneNumber/updating',
  Updated: 'phoneNumber/updated',
  Error: 'phoneNumber/error'
}

export const actionCreators = {
  getPhoneNumber: () => (dispatch) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.userProfile.getPhoneNumber()
      .then(response => {
        dispatch({ type: actionTypes.Fetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { fetching: false } }))
  },
  updatePhoneNumber: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Updating })
    context.api.userProfile.updatePhoneNumber(input)
      .then(response => {
        dispatch({ type: actionTypes.Updated, payload: input })
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, phone: action.payload.phoneNumber }

    case actionTypes.Updating: return { ...state, updating: true }
    case actionTypes.Updated: return { ...state, updating: false, phone: action.payload.phoneNumber }
    case actionTypes.Error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/phoneNumber.js